import { render, staticRenderFns } from "./norilskMap.vue?vue&type=template&id=3dae9753&scoped=true&"
import script from "./norilskMap.vue?vue&type=script&lang=js&"
export * from "./norilskMap.vue?vue&type=script&lang=js&"
import style0 from "./norilskMap.vue?vue&type=style&index=0&id=3dae9753&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dae9753",
  null
  
)

export default component.exports